const state = () => ({
    isBlur: false,
    isMuteAudio: false,
    isMuteVideo: false,
    isDenoiser: false,
})

const mutations = {
    setIsMuteAudio(state, value) {
        state.isMuteAudio = value
    },

    setIsMuteVideo(state, value) {
        state.isMuteVideo = value
    },

    setIsBlur(state, value) {
        state.isBlur = value
    },

    setIsDenoiser(state, value) {
        state.isDenoiser = value
    },
}

const getters = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
